import React, { Component } from "react";
import Spinner from "../../atoms/Spinner/index";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Button,
  Paper
} from "@material-ui/core";
import Numberformat from "../../atoms/Numberformat/index";
import PayForm from "../PayForm/container";

export default class OrdersAll extends Component {
  constructor(props) {
    super();
    this.showPayDialog = this.showPayDialog.bind(this);
    this.state = {
      open: false,
      orderIndex: 0
    };
  }
  componentDidMount() {
    this.props.getOrders();
  }
  showPayDialog(row) {
    this.setState({ open: true, orderIndex: row });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleBackup() {
    this.props.requestBackup({ type: "backupPaidOrders" });
  }

  handleExportPaidOrdersForTokenAssignments() {
    this.props.requestBackup({ type: "exportPaidOrdersForTokenAssignments" });
  }

  renderFinalToken(o) {
    if (o.Status === "created" || o.token === o.token_payed) {
      return <Numberformat value={o.token} digits={6} />;
    } else {
      return (
        <React.Fragment>
          <Numberformat value={o.token_payed} digits={6} />
          <br />
          <small style={{ textDecoration: "line-through" }}>
            <Numberformat value={o.token} digits={6} />
          </small>
        </React.Fragment>
      );
    }
  }

  renderFinalSum(o) {
    if (o.Status === "created" || o.sum === o.sum_payed) {
      return (
        <React.Fragment>
          <Numberformat value={o.sum} digits={o.currency === "EUR" ? 2 : 6} />
          &nbsp;{o.currency}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Numberformat
            value={o.sum_payed}
            digits={o.currency === "EUR" ? 2 : 6}
          />
          &nbsp;{o.currency}
          <br />
          <small style={{ textDecoration: "line-through" }}>
            <Numberformat value={o.sum} digits={o.currency === "EUR" ? 2 : 6} />
          </small>
        </React.Fragment>
      );
    }
  }

  render() {
    const {
      fetching,
      fetching_error,
      fetching_success,
      Orders
    } = this.props.allorders;
    if (fetching) return <Spinner />;
    if (fetching_error) return "ERROR: could not load data";
    if (fetching_success) {
      return (
        <React.Fragment>
          <Paper align="right">
            <Button
              onClick={event =>
                this.handleExportPaidOrdersForTokenAssignments()
              }
              id="btnExportPaidOrdersForTokenAssignments"
            >
              Export For Token Assignments
            </Button>
            <Button
              onClick={event => this.handleBackup()}
              id="btnBackupPaidOrders"
            >
              Backup
            </Button>
          </Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Reference</TableCell>
                <TableCell>Email</TableCell>
                <TableCell numeric>Token</TableCell>
                <TableCell numeric>Total</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>&nbsp;</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Orders.map((o, index) => (
                <TableRow key={o.OrderID} className="orderRow">
                  <TableCell>
                    {new Date(o.OrderDate).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{o.OrderNumber}</TableCell>
                  <TableCell>{o.Email}</TableCell>
                  <TableCell numeric>{this.renderFinalToken(o)}</TableCell>
                  <TableCell numeric>{this.renderFinalSum(o)}</TableCell>
                  <TableCell>
                    {o.Status.toLowerCase() === "payed" ? "paid" : o.Status}
                  </TableCell>
                  <TableCell>
                    {o.Status === "created" && o.currency !== "ETH" && (
                      <Button
                        onClick={event => this.showPayDialog(index)}
                        className="btnMarkOrderAsPaid"
                        id={`btnMarkPaid${o.OrderNumber}`}
                      >
                        Mark as paid
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <PayForm
            order={Orders[this.state.orderIndex]}
            open={this.state.open}
            onClose={this.handleClose}
          />
        </React.Fragment>
      );
    }
    return null;
  }
}
